import type { ValuesType } from 'utility-types'

export const ProductsPerRow = {
  MOBILE: 2,
  TABLET: 3,
  DESKTOP: 4,
} as const

export const SIZE_SELECTOR_SLIDEIN = 'SizeSelectorSlideIn'
export const SIZE_BACK_IN_STOCK_SLIDEIN = 'SizeBackInStockSlideIn'
export const COINS_FAQ_SLIDEIN = 'CoinsFaqSlideIn'
export const PRODUCT_CARD_IMAGE_EAGER_LOAD_SIZE = 8
export const PRODUCT_CARD_SKELETON_LOADERS_SIZE = 20
export const PRODUCT_CARD_SIBLINGS_LIMIT = 4
export const FETCH_PRODUCTS_CACHE_TTL = 1000
export const PRODUCTS_PER_PAGE = 24
export const PRODUCT_IMAGE_QUALITY_MODIFIER = '75'
export const ORDER_GROUPS_PER_PAGE = 8

export const productListingMetaData = {
  name: 'PDP',
  id: 'PDP',
} as const

export const ProductColor: Record<string, string | string[]> = {
  white: '#FFFFFF',
  gold: '#FFD700',
  beige: '#F5F5DC',
  black: '#000000',
  grey: '#808080',
  red: '#FF0000',
  blue: '#0000FF',
  green: '#008000',
  yellow: '#FFFF00',
  orange: '#FFA500',
  brown: '#A52A2A',
  light_pink: '#FFB6C1',
  purple: '#800080',
  multicolour: ['#0000FF', '#FFA500', '#FF0000', '#008000'],
  camouflage: ['#4B5320', '#78866B', '#556B2F', '#808000'],
  turquoise: '#40E0D0',
  silver: '#C0C0C0',
  undefined_color: '#E5E7EB',
}

// TODO: Refactor for more multilanguage shops
export const GENDER_MAPPING = {
  // MEN
  men: 'men',
  mezczyzni: 'men',
  // WOMEN
  women: 'women',
  kobiety: 'women',
  // KIDS
  kids: 'kids',
  dzieci: 'kids',
} as const

export const GENDER_MAPPING_POLISH = {
  mezczyzni: 'męskie',
  kobiety: 'damskie',
  dzieci: 'dziecięce',
} as const

export type GenderMappingKeys = keyof typeof GENDER_MAPPING

export type GenderMappingType = ValuesType<typeof GENDER_MAPPING>
export type AllGenderMappingType = GenderMappingType | 'neutral'

export const SHOE_SIZES_COUNTRIES = {
  EU: 'EU',
  US: 'US',
  UK: 'UK',
} as const

export const SHOE_SIZES_ATTRIBUTES_KEYS = {
  EU: 'sizeEu',
  US: 'sizeUs',
  UK: 'sizeUk',
} as const

export type SizeSystem = keyof typeof SHOE_SIZES_ATTRIBUTES_KEYS
export type SizeKey = (typeof SHOE_SIZES_ATTRIBUTES_KEYS)[SizeSystem]

export type ShoeSizesCountries = keyof typeof SHOE_SIZES_COUNTRIES

export const SIZES_MAPPING = {
  EU: {
    '36': '36',
    '37': '37',
    '38': '38',
    '39': '39',
    '40': '40',
    '41': '41',
    '42': '42',
    '43': '43',
    '44': '44',
    '45': '45',
    '46': '46',
    '47': '47',
    '48': '48',
    '49': '49',
  },
  US: {
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
  },
  UK: {
    '4': '4',
    '5': '5',
    '6': '6',
    '7': '7',
  },
} as const

export type SizesMapping = typeof SIZES_MAPPING
